// import React from "react";
// import { motion } from "framer-motion";
// import "./about.css";
// import Highlight from "../../component/highlight/highlight";

// const data = [
//   {
//     img: "/images/pristin5.png",
//     title: "Prime Connectivity in the Heart of Pune",
//     text: (
//       <>
//         <Highlight>Viman Nagar</Highlight> has emerged as one of Pune’s most desirable residential zones.
//         With the airport just minutes away, the Pune-Ahmednagar Highway, Kharadi, Yerwada, and Kalyani Nagar
//         easily accessible, the location offers seamless connectivity for both professionals and families.
//       </>
//     ),
//   },
//   {
//     img: "/images/pristine6.png",
//     title: "High Appreciation with Lifestyle Value",
//     text: (
//       <>
//         <Highlight>Viman Nagar</Highlight> has seen exponential real estate appreciation over the years.
//         Projects like <Highlight>Pristine Kyra</Highlight> stand out for their combination of location,
//         design, and developer reputation. Whether you are buying a home to live in or as an investment,
//         Kyra offers strong potential for both lifestyle satisfaction and financial growth.
//       </>
//     ),
//   },
//   {
//     img: "/images/pristine29.png",
//     title: "Everything You Need, Just Minutes Away",
//     text: (
//       <>
//         Located next to <Highlight>Symbiosis International School</Highlight>, the project is ideal for families.
//         The <Highlight>EON IT Park</Highlight>, Weikfield IT Hub, and World Trade Center are nearby, making it
//         a great choice for professionals seeking work-life balance. Proximity to Pune Airport and Phoenix Marketcity
//         ensures convenience for travel, shopping, and entertainment.
//       </>
//     ),
//   },
//   {
//     img: "/images/pristine3.png",
//     title: "Elite 3.5 & 4.5 BHK Homes in Pune’s Prime Location",
//     text: (
//       <>
//         <Highlight>Pristine Kyra</Highlight> is an exclusive residential project offering ultra-luxurious 3.5
//         and 4.5 BHK apartments in Viman Nagar, Pune. With only 4 residences per floor, it ensures unmatched
//         privacy, space, and premium urban living.
//       </>
//     ),
//   },
// ];

// const About = () => {
//   return (
//     <section className="about-section" id="about">

//       <h2>MORE ABOUT PRISTINE <span>KYRA</span></h2>

//       {data.map((item, index) => (
//         <motion.div
//           className={`about-row ${index % 2 === 0 ? "normal" : "reverse"}`}
//           key={index}
//           initial={{ opacity: 0, y: 80 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, delay: index * 0.15 }}
//           viewport={{ once: true, amount: 0.3 }}
//         >

//           {/* IMAGE */}
//           <div className="about-img">
//             <img src={item.img} alt={item.title} />
//           </div>

//           {/* TEXT */}
//           <div className="about-text">
//             <h3>{item.title}</h3>
//             <p>{item.text}</p>
//           </div>

//         </motion.div>
//       ))}

//     </section>
//   );
// };

// export default About;










import React, { useState } from "react";
import { motion } from "framer-motion";
import "./about.css";
import Highlight from "../../component/highlight/highlight";
// import { useNavigate } from "react-router-dom";


const data = [
  {
    img: "/images/pristin5.png",
    title: "Prime Connectivity in the Heart of Pune",
    text: (
      <>
        <Highlight>Viman Nagar</Highlight> has emerged as one of Pune’s most desirable residential zones.
        With the airport just minutes away, the Pune-Ahmednagar Highway, Kharadi, Yerwada, and Kalyani Nagar
        easily accessible, the location offers seamless connectivity for both professionals and families.
      </>
    ),
  },
  {
    img: "/images/pristine6.png",
    title: "High Appreciation with Lifestyle Value",
    text: (
      <>
        <Highlight>Viman Nagar</Highlight> has seen exponential real estate appreciation over the years.
        Projects like <Highlight>Pristine Kyra</Highlight> stand out for their combination of location,
        design, and developer reputation.
      </>
    ),
  },
  {
    img: "/images/pristine29.png",
    title: "Everything You Need, Just Minutes Away",
    text: (
      <>
        Located next to <Highlight>Symbiosis International School</Highlight>, the project is ideal for families.
        The <Highlight>EON IT Park</Highlight> and World Trade Center are nearby.
      </>
    ),
  },
  {
    img: "/images/pristine3.png",
    title: "Elite 3.5 & 4.5 BHK Homes in Pune’s Prime Location",
    text: (
      <>
        <Highlight>Pristine Kyra</Highlight> offers ultra-luxurious homes with privacy and space.
      </>
    ),
  },
];

const categories = [
  {
    key: "bedroom",
    title: "Luxury Bedrooms",
    text: "Spacious bedrooms designed for comfort, natural light, and premium living experience.",
    images: ["/images/bedroom1.png", "/images/bedroom2.png", "/images/bedroom3.png", "/images/bedroom4.png"],
  },
  {
    key: "balcony",
    title: "Elegant Balconies",
    text: "Wide balconies offering scenic views and peaceful outdoor relaxation spaces.",
    images: ["/images/balcony.png", "/images/pristine3.png"],
  },
  {
    key: "Living",
    title: "Spacious Living Area",
    text: "Spacious bedrooms designed for comfort, natural light, and premium living experience.",
    images: ["/images/living.png", "/images/living2.png"],
  },
];

export default function About() {
  const [active, setActive] = useState("bedroom");
  const [imgIndex, setImgIndex] = useState(0);
  // const current = categories.find((c) => c.key === active);

  const nextImage = () => {
    setImgIndex((prev) =>
      prev === current.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setImgIndex((prev) =>
      prev === 0 ? current.images.length - 1 : prev - 1
    );
  };

  // reset image when category changes
  const changeCategory = (key) => {
    setActive(key);
    setImgIndex(0);
  };
  const current = categories.find((c) => c.key === active);
  // const navigate = useNavigate();
  return (
    <section className="about-section" id="about">


      <div className="about-overview">
        <p>OverView</p>
        <h3>Pristine Kyra</h3>

        <p>
          Book your new apartment at Pristine Kyra in Pune

          Investors and homeowners looking for classy apartments in Pune must have a look at Pristine Kyra. Developed in Viman Nagar, one of the prime localities in the city, this residential estate offers a superior quality of lifestyle. Millennials and corporate professionals are looking to buy their homes in this new complex. These Pristine Kyra flats for sale are available in 3.5 and 4.5 BHK formats. You can choose the desired configuration from 139 residential units. These apartments has 12 floors, 5 towers and 230 luxury residences. The project spans 3.36 acres, and you can enjoy lots of common spaces in the complex.

          The demand for luxury apartments in Viman Nagar has been increasing significantly over the years. This would be the right opportunity for you to purchase the homes, as the property value has been escalating over the years. The developers have come up with a practical layout and intelligent floor plan to maximize the available space for the residents. With tall ceilings, wide balconies and large windows, a healthy and vibrant living environment awaits you in this complex. Naturally, investors are willing to book their apartments at Pristine Kyra Viman Nagar before the prices escalate.

          Some of the amenities in this new gated community include indoor games and kids’ play areas. You also have access to a swimming pool and can spend quality time in the open spaces. The developers have also integrated the estate with a multipurpose hall, video security facilities, car parking spaces, and a jogging track. You can check out the Pristine Kyra photos to get a comprehensive overview of the range of amenities available in this project.

          The strategic location of Pristine Properties Pune makes it a prime choice for owners. You can get across to Reliance Mart and Phoenix Market City in a quick time through the roadways. The Pune International Airport lies 10 Km. away, while the Pune Railway Station is located at a distance of 15 Km. from these homes. Some of the reputed academic institutions around the estate are the Podar International School and Victorious Kidss Educares.

          Check out the Pristine Kyra price for the configuration you are keen to invest in. The lifestyle in this project looks blissful, so book your new apartment at Pristine Kyra Pune early and embrace the luxury that the developers have come up with for you.
        </p>

      </div>





      {/* TITLE */}
      <motion.h2
        className="about-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        MORE ABOUT <span>PRISTINE KYRA</span>
      </motion.h2>

      {/* STORY SECTION */}
      {data.map((item, index) => (
        <motion.div
          className={`about-row ${index % 2 === 0 ? "normal" : "reverse"}`}
          key={index}
          initial={{ opacity: 0, y: 60, scale: 0.98 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          transition={{
            duration: 0.7,
            ease: "easeOut",
            delay: index * 0.1,
          }}
          viewport={{ once: true, amount: 0.3 }}
        >
          {/* IMAGE */}
          <motion.div
            className="about-img"
            whileHover={{ scale: 1.03 }}
          >
            <img src={item.img} alt={item.title} />
          </motion.div>

          {/* TEXT */}
          <div className="about-text">
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        </motion.div>
      ))}

      {/* CATEGORY GALLERY SECTION */}

      <div className="category-section">

        {/* TABS */}
        <div className="tabs">
          {categories.map((cat) => (
            <button
              key={cat.key}
              className={active === cat.key ? "active" : ""}
              onClick={() => changeCategory(cat.key)}
            >
              {cat.key.toUpperCase()}
            </button>
          ))}
        </div>

        {/* CONTENT */}
        <motion.div
          className="category-content"
          key={active}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >

          {/* TEXT */}
          <div className="category-text">
            <h3>{current.title}</h3>
            <p>{current.text}</p>

            {/* NAV BUTTONS */}
            <div className="nav-buttons">
              <button onClick={prevImage}>Prev</button>
              <button onClick={nextImage}>Next</button>
            </div>
          </div>

          {/* IMAGE VIEWER (ONLY ONE IMAGE NOW) */}
          <div className="category-images">
            <motion.img
              key={imgIndex}
              src={current.images[imgIndex]}
              alt=""
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
            />
          </div>

        </motion.div>

      </div>
      {/* <div
        className="quote-banner"
        onClick={() => navigate("/contact")}
      > */}
      <div
  className="quote-banner"
  onClick={() =>
    document.getElementById("contact")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    })
  }
>
        <div className="quote-overlay" />

        <img
          src="/images/pristine.png"
          alt="Quotation"
          className="quote-img"
        />

        <div className="quote-text">
          <h3>Get Full Project Quotation</h3>
          <p>Click here to view pricing & exclusive offers</p>
        </div>
      </div>

      {/* CONTACT INFO SECTION */}
      <div className="about-contact">

        <div className="about-col">
          <h3>A Smart Investment for the Future</h3>

          <p>
            Viman Nagar has seen exponential real estate appreciation over the years.
            Projects like Pristine Kyra stand out for their combination of location,
            design, and developer reputation. Whether you are buying a home to live in
            or as an investment, Kyra offers strong potential for both lifestyle
            satisfaction and financial growth.
          </p>
          <p>Located right next to Symbiosis International School, the project is ideal for families with school-going children. The EON IT Park, Weikfield IT Hub, and World Trade Center are nearby, making it a great choice for professionals seeking work-life balance. The proximity to Pune Airport and Phoenix Marketcityensures that travel, shopping, and entertainment are always just around the corner.</p>
        </div>

        <div className="about-col">
          <h3>Want to know more?</h3>

          <p>
            For more detailed information about Pristine Kyra, floor plans, pricing,
            and availability, feel free to connect with our team. We are here to help
            you understand every aspect of the project and guide you in making the
            right decision.
          </p>

          <p>
            Whether you are looking for a dream home or a long-term investment in
            Pune’s prime location, our experts will provide complete assistance with
            site visits, brochures, and project walkthroughs.
          </p>
        </div>

      </div>

    </section>
  );
}